import React, { useState, useEffect } from 'react';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenu(false);
  };

  const navLinks = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'president', label: 'Founder & President' },
    { id: 'vicepresident', label: 'Vice President' },
    { id: 'secretary', label: 'Secretary' },
    { id: 'dean', label: 'Dean' },
    { id: 'principal', label: 'Principal' },
    { id: 'courses', label: 'Courses' },
    { id: 'labs', label: 'Labs' },
    { id: 'achievements', label: 'Achievements' },
    { id: 'events', label: 'Events' },
    { id: 'placement', label: 'Placement' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <ul className="nav-links">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button onClick={() => scrollToSection(link.id)}>{link.label}</button>
            </li>
          ))}
        </ul>
        <button className="mobile-menu-btn" onClick={() => setMobileMenu(!mobileMenu)}>
          {mobileMenu ? '✕' : '☰'}
        </button>
      </div>
      {mobileMenu && (
        <ul className="mobile-nav">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button onClick={() => scrollToSection(link.id)}>{link.label}</button>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;